var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0H0V2H8V0ZM8 4H0V6H8V4ZM0 8H8V10H0V8ZM8 12H0V14H8V12ZM0 16H8V18H0V16ZM18 0H10V2H18V0ZM10 4H18V6H10V4ZM18 8H10V10H18V8ZM10 12H18V14H10V12ZM18 16H10V18H18V16Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailView);
export default __webpack_public_path__ + "static/media/DetailView.eeb4cd2faee07124d804537b15f3f729.svg";
export { ForwardRef as ReactComponent };